var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',[_c('forgot-password-card',{attrs:{"success-message":_vm.successMessage,"candidates":_vm.candidates,"errors":_vm.errors},on:{"click":_vm.handleClick}}),_vm._v(" "),_c('forgot-password-modal',{ref:"forgotPasswordModal",on:{"forgot-password-success":_vm.handleForgotPassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }